import { render, staticRenderFns } from "./Func31Novo.vue?vue&type=template&id=0c0f91d3&scoped=true"
import script from "./Func31Novo.vue?vue&type=script&lang=js"
export * from "./Func31Novo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c0f91d3",
  null
  
)

export default component.exports